<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="queryInfo.official_name" placeholder="名称" />
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="getPostList(true)">查询</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialogVisibleFn">添加映射关系</el-button>
        </el-col>
      </el-row>

      <!-- 标签列表区域 -->
      <el-table :data="postlist" border stripe>
        <el-table-column label="id" prop="id"></el-table-column>
        <el-table-column label="官方客服企微id" prop="official_account_id"></el-table-column>
        <el-table-column label="官方客服名称" prop="official_account_name"></el-table-column>
        <el-table-column label="客服名称" prop="user_detail.user_name"></el-table-column>
        <el-table-column label="客服工号" prop="user_job_num"></el-table-column>
        <el-table-column label="部门" prop="user_detail.dept_name"></el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-button type="danger" size="mini" @click="removePostById(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[1,10, 20, 50]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加标签的对话框 -->
    <el-dialog title="添加标签" :visible.sync="addDialogVisible" width="500px" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="150px">
        <el-form-item label="官方客服企微id" prop="official_user_id">
            <el-input v-model="addForm.official_user_id"  placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="官方客服名称" prop="official_user_name">
          <el-input v-model="addForm.official_user_name"  placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="客服" prop="user_job_num">
          <el-select ref="elSelect" class="width-100" v-model="addForm.user_job_num" placeholder="请选择">
            <el-option
              :value="addForm.job_num"
              :label="addForm.DeptName"
              style="height: auto"
            >
              <el-tree
                :props="props"
                :load="loadNode"
                @node-click="handleNodeClick"
                lazy>
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPost">确 定</el-button>
      </span>
    </el-dialog>
   </div>
</template>

<script>
  import { chat_del, chat_get, chat_post, toForm } from '@/api'
  export default {
    data() {
      return {
        queryInfo: {
          pagenum: 1,
          pagesize: 10,
          official_name: ''
        },
        postlist: [],
        total: 0,
        addDialogVisible: false,
        addForm: {
          official_user_id: '',
          official_user_name: '',
          user_job_num: '',
          job_num: ''
        },
        addFormRules: {
          official_user_id: [
            { required: true, message: '请输入内容', trigger: 'blur' }
          ],
          official_user_name: [
            { required: true, message: '请输入内容', trigger: 'blur' }
          ],
          user_job_num: [
            { required: true, message: '请选择客服', trigger: 'change' }
          ]
        },
        props: {
          label: 'DeptName',
          children: 'children',
          isLeaf: 'leaf'
        }
      }
    },
    created() {
      this.getPostList()
    },
    methods: {
      getPostList(init) {
        if (init) {
          this.queryInfo.pagenum = 1
        }
        chat_get(`/admin/v1/official/customer/mapping?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&official_name=${ this.queryInfo.official_name }`, {}, res => {
          if(res.status == 200) {
            let { list: postList, total } = res.data.MessageContent
            this.total = total
            this.postlist = postList
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getPostList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getPostList()
      },
      // 监听添加标签对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },
      // 点击按钮，添加新标签
      addPost() {
        let params = this.addForm
        let api = this.addForm.id ? '/admin/v1/official/customer/mapping/update' : '/admin/v1/official/customer/mapping/add'
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          chat_post(api, params, res => {
            if(res.status == 200) {
              this.$message.success('保存成功！')
              // 隐藏添加标签的对话框
              this.addDialogVisible = false
              // 重新获取标签列表数据
              this.getPostList()
            }
          })
        })
      },
      addDialogVisibleFn() {
        this.addForm = {
          official_user_id: '',
          official_user_name: '',
          user_job_num: '',
          job_num: ''
        }
        this.addDialogVisible = true
      },
      showEditDialog(row) {
        this.addForm = {
          official_user_id: row.official_account_id,
          id: row.id,
          user_job_num: row.user_job_num,
          job_num: row.user_job_num,
          DeptName:  row.user_detail.user_name,
          official_user_name: row.official_account_name
        }
        this.addDialogVisible = true
      },
      // 根据Id删除对应的标签信息
      removePostById(item) {
        let vm = this;
        this.$confirm( `确定删除吗?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_post(`/admin/v1/official/customer/mapping/del`, {
            id: item.id
          }, res => {
            if(res.status == 200) {
              vm.getPostList()
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }
          })
        })
      },
      loadNode(node, resolve) {
        // 最后一级
        if(node.data && node.data.NotHasChildren) return;
        if (node.level === 0) {
          chat_get(`/admin/deptList?Id=1`, {}, res => {
            if(res.status == 200) {
              return resolve(res.data.MessageContent)
            }
          })
        }
        if (node.level > 0) {
          chat_get(`/admin/getDeptAndUserByPid?id=${node.data.Id}`, {}, res => {
            if (res.status == 200) {
              let list = []
              let { DeptList, UserList } = res.data
              list = DeptList ? DeptList : []
              list = UserList ? list.concat(UserList) : list
              return resolve(list)
            }
          })
        }
      },
      handleNodeClick(sel) {
        // 如果不是最后一级则return
        if (sel.hasOwnProperty('Ancestors')) return;
        let { workNo } = sel;
        this.addForm.DeptName = sel.DeptName
        this.addForm.job_num = workNo
        this.addForm.user_job_num = workNo
        this.$refs.elSelect.blur()
      },
    }
  }
</script>

<style lang="less" scoped>
 .el-select-dropdown__item {
    padding: 0;
    text-align: center;
  }
</style>
